import { render } from "./opened-tickets.vue?vue&type=template&id=844d5f10"
import script from "./opened-tickets.vue?vue&type=script&lang=js"
export * from "./opened-tickets.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__